import React from 'react';
import { cn } from '@/lib/utils';

/** Innholdsbredde for den offentlige nettsiden. */
export const SITE_CONTAINER = 'mx-auto w-full max-w-[1280px] px-5 sm:px-8 lg:px-10';

export function Container({ className, children, ...props }) {
  return (
    <div className={cn(SITE_CONTAINER, className)} {...props}>
      {children}
    </div>
  );
}

export function Section({ id, className, tone = 'white', children, ...props }) {
  return (
    <section id={id} className={cn('scroll-mt-20 py-16 sm:py-24', tone === 'muted' ? 'bg-[var(--hr-bg)]' : tone === 'navy' ? 'bg-[var(--hr-navy)] text-white' : 'bg-white', className)} {...props}>
      {children}
    </section>
  );
}

export function SectionHeading({ eyebrow, title, lead, align = 'left', className, children, onDark = false }) {
  return (
    <div className={cn('flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between', className)}>
      <div className={cn('max-w-[640px]', align === 'center' && 'mx-auto text-center')}>
        {eyebrow && <div className={cn('mb-3 text-[12px] font-semibold uppercase tracking-[0.12em]', onDark ? 'text-[var(--hr-accent)]' : 'text-[var(--hr-accent-text)]')}>{eyebrow}</div>}
        <h2 className={cn('font-display text-[30px] font-semibold leading-[1.1] tracking-[-0.02em] sm:text-[38px]', onDark ? 'text-white' : 'text-[var(--hr-heading)]')}>{title}</h2>
        {lead && <p className={cn('mt-4 text-[16px] leading-7 sm:text-[17px]', onDark ? 'text-white/75' : 'text-[var(--hr-muted)]')}>{lead}</p>}
      </div>
      {children && <div className="shrink-0">{children}</div>}
    </div>
  );
}
